import React from 'react';
import { BannerState, BannerType } from './types';
import CancellationBanner from './components/CancellationBanner';
import PaymentFailureBanner from './components/PaymentFailureBanner';

interface BannerManagerProps {
	bannerState: BannerState;
	setIsVisible: (visible: boolean) => void;
}

export default function BannerManager({
	bannerState,
	setIsVisible,
}: BannerManagerProps) {
	if (!bannerState.isVisible || !bannerState.type) {
		return null;
	}

	const banners: Record<BannerType, React.ReactNode> = {
		cancellation: (
			<CancellationBanner setIsVisible={setIsVisible} type={bannerState.type} />
		),
		payment_failure: (
			<PaymentFailureBanner
				setIsVisible={setIsVisible}
				type={bannerState.type}
			/>
		),
	};

	return banners[bannerState.type] || null;
}
